export default "__VITE_ASSET__Cs8NC8k___"